import { defineComponent } from 'vue';
import { usecommonStore } from "~src/stores/CommonStore";
import { IMAGE_STORAGE_URL } from '~src/utils/constant';
import { stringToSlug } from '~src/helpers/CommonHelper';
import type { ILeague } from "~src/interfaces";

export const globalMixin = defineComponent({
  data() {
    return {};
  },
  computed: {
    gSportType() {
      const commonStore = usecommonStore();

      return commonStore.getSportType;
    },
    gSiteName() {
      const commonStore = usecommonStore();

      return commonStore.getSiteName;
    },
    gIsLiveSite() {
      const host = window.location.hostname;

      return (
        !host.includes('localhost') &&
        !host.includes('plugin.') &&
        !host.includes('plugin-prod.')
      );
    }
  },
  methods: {
    getImgUrlBySport(type: any, id = "default", isSmall = true, sportType = undefined) {
      return `${IMAGE_STORAGE_URL}/${sportType || this.gSportType}/${type}/${id || "default"}/image${
        isSmall ? "/small" : ""
      }`;
    },
    getCompetitionShortCode(competition: ILeague, isShowShortCode = false) {
      if (isShowShortCode) {
        return competition.short_code || competition.short_name || competition.name || '';
      }

      return competition.short_name_vi || competition.short_name || competition.name || competition.short_code || '';
    },
    getLinkTeamDetail(teamId: any, teamName: any, isGoTo = false) {
      let link = null;

      const currentDomain = window.location.hostname;
      if (["localhost", "plugin.api-football.xyz"].includes(currentDomain)) {
        link = `/public/team_detail.html?teamId=${teamId}`;
      } else {
        const slug = teamName ? stringToSlug(teamName) + '-' + teamId : teamId;
        link = `/doi-bong/${slug}`;
      }

      if(isGoTo) {
        window.location.href = link;
      } else {
        return link;
      }
    },
    getLinkPlayerDetail(player: any, isGoTo = false) {
      let link = null;

      const playerId = player?.id;
      const playerName = player?.name;

      const currentDomain = window.location.hostname;
      if (["localhost", "plugin.api-football.xyz"].includes(currentDomain)) {
        link = `/public/player_detail.html?playerId=${playerId}`;
      } else {
        const slug = playerName ? stringToSlug(playerName) + '-' + playerId : playerId;
        link = `/cau-thu/${slug}`
      }

      if(isGoTo) {
        window.location.href = link;
      } else {
        return link;
      }
    },
  },
});
